import React from "react"
import {
  Fieldset,
  Label,
  Legend,
  RadioContentWrapper,
  RadioInput,
  RadioItemWrapper,
  RadioWrapper,
  Span,
  ValidationText
} from "../../styles"
import PropTypes from "prop-types"

function RadioGroup({ options, onChange, legend, id, value, validationText, ...otherProps }) {
  const handleOnChangeValue = (e) => {
    const selectedValue = options.find(
      (option) => String(option.value) === String(e.target.value)
    )
    if (!selectedValue) return
    onChange(selectedValue.value, id)
  }
  return (
    <Fieldset id={id}>
      {legend && (
        <Legend role="legend" dangerouslySetInnerHTML={{ __html: legend }} />
      )}
      <RadioWrapper>
        {options.map((option) => (
          <RadioItemWrapper key={option.value}>
            <Label>
              <RadioInput
                value={option.value}
                name={id}
                checked={value === option.value}
                onChange={handleOnChangeValue}
                {...otherProps}
              />
              <Span>{option.label || String(option.value)}</Span>
            </Label>
            {option.subcontent && value === option.value && (
              <RadioContentWrapper>{option.subcontent}</RadioContentWrapper>
            )}
          </RadioItemWrapper>
        ))}
      </RadioWrapper>
    {validationText && <ValidationText htmlFor={id}>{validationText}</ValidationText>}
    </Fieldset>
  );
}

RadioGroup.propTypes = {
  /** Called on change of value, with new value and id */
  onChange: PropTypes.func,
  /** The legend for the input */
  legend: PropTypes.string,
  /** A unique id for the input, e.g a field name */
  id: PropTypes.string,
  /** Array of options to display */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      /** The value of the option */
      value: PropTypes.any,
      /** The display label for the option. Uses value if not set */
      label: PropTypes.string,
      /** Any content that should show when the option is checked */
      subcontent: PropTypes.node,
    })
  ),
  /** The value of the input */
  value: PropTypes.any,
}

export default RadioGroup
